import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import "./OrganizationChart.css";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownLong, faUpload } from "@fortawesome/free-solid-svg-icons";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";
import { useDispatch, useSelector } from "react-redux";
import {
  GetComplanintReport,
  OrganizationChartReport,
} from "../../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { ClipLoader } from "react-spinners";
/* ================= INPUT FIELD ================= */
const OrgChartInput = ({ placeholder }) => {
  return (
    <Form.Group className="form_group file_field">
      <div className="absolute_fields">
        <Form.Control placeholder={placeholder} />
      </div>
    </Form.Group>
  );
};

/* ================= COMPONENT ================= */
function OrganizationChart({ handleClose }) {
  const [isGenerated, setIsGenerated] = useState(false);
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  const dispatch = useDispatch();
  const [loader, setLoder] = useState(false);
  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }
    setLoder(true);
    try {
      const fileUrl = `${process.env.REACT_APP_IMG_URL}${invoicePath}`;

      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);
      setLoder(false);
      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `OrganizationChart.pdf`); // you can make this dynamic
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };
  const reportgenerate = async () => {
    setLoder(true);
    const response = await dispatch(OrganizationChartReport());

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      handleDownloadInvoice(path);
    } else {
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(
    FixIDS.organization_chart.List,
  );

  return (
    <>
      <section className="Imperiality OrgChartInput">
        <div className="back_div">
          <Common_Back_Btn backText="Organization Chart" />
        </div>

        <div className="org-chart-wrapper">
          {/* ACTION BUTTONS */}
          <div className="org-chart-actions">
            {!isGenerated ? (
              <div
                className="permission_btn_holder"
                style={{ borderTop: "none" }}
              >
                {loader ? (
                  <>
                    <div className="permission_btn_holder mt-4">
                      <ClipLoader />
                    </div>
                  </>
                ) : (
                  <Button
                    className="permission_btn Yes_btn"
                    onClick={reportgenerate}
                    // onClick={() => setIsGenerated(true)}
                  >
                    Generate Organization Chart
                  </Button>
                )}
              </div>
            ) : (
              <div
                className="permission_btn_holder"
                style={{ borderTop: "none" }}
              >
                {!success ? (
                  <>
                    <Button
                      type="button"
                      className="permission_btn No_btn"
                      onClick={reportgenerate}
                    >
                      Download
                    </Button>

                    <Button
                      type="submit"
                      className="permission_btn Yes_btn"
                      onClick={() => {
                        setSuccess(true);
                      }}
                    >
                      Save
                    </Button>
                  </>
                ) : (
                  <Success_Toster successText={"Save Audit Successfully!"} />
                )}
              </div>
            )}
          </div>

          {/* ORGANIZATION CHART */}
          {haveReadPermission && (
            <div className="org-chart">
              <div className="box orange">
                {isGenerated ? (
                  <OrgChartInput placeholder="Name Of CEO LAB" />
                ) : (
                  "CEO LAB"
                )}
                <span>(Manager Mines)</span>
              </div>

              <div className="arrow-down">
                <FontAwesomeIcon icon={faArrowDownLong} />
              </div>

              <div className="box aqua">
                {isGenerated ? (
                  <OrgChartInput placeholder="Name Of AQM" />
                ) : (
                  "Area Quality Manager"
                )}
                <span>(AQM)</span>
              </div>

              <div className="arrow-down">
                <FontAwesomeIcon icon={faArrowDownLong} />
              </div>

              <div className="box purple">
                {isGenerated ? (
                  <OrgChartInput placeholder="Name Of QM" />
                ) : (
                  "Quality Manager"
                )}
                <span>(QM)</span>
              </div>

              <div className="arrow-down">
                <FontAwesomeIcon icon={faArrowDownLong} />
              </div>

              <div className="box green">
                {isGenerated ? (
                  <OrgChartInput placeholder="Name Of TM" />
                ) : (
                  "Technical Manager"
                )}
                <span>(TM)</span>
              </div>

              <div className="horizontal-line"></div>

              <div className="bottom-row">
                <div className="text-center">
                  <div className="arrow-down">
                    <FontAwesomeIcon icon={faArrowDownLong} />
                  </div>
                  <div className="box pink">
                    {isGenerated ? (
                      <OrgChartInput placeholder="Name Of Chemist" />
                    ) : (
                      "Lab Technician"
                    )}
                    <span>(Chemist)</span>
                  </div>
                </div>
                <div className="text-center">
                  <div className="arrow-down">
                    <FontAwesomeIcon icon={faArrowDownLong} />
                  </div>
                  <div className="box pink">
                    {isGenerated ? (
                      <OrgChartInput placeholder="Name Of Assistant" />
                    ) : (
                      "Lab Technician"
                    )}
                    <span>(Assistant)</span>
                  </div>
                </div>

                <div className="text-center">
                  <div className="arrow-down">
                    <FontAwesomeIcon icon={faArrowDownLong} />
                  </div>
                  <div className="box pink">
                    {isGenerated ? (
                      <OrgChartInput placeholder="Name Of Clerk" />
                    ) : (
                      "Clerk"
                    )}
                  </div>
                </div>

                <div className="text-center">
                  <div className="arrow-down">
                    <FontAwesomeIcon icon={faArrowDownLong} />
                  </div>
                  <div className="box pink">
                    {isGenerated ? (
                      <OrgChartInput placeholder="Name Of Sample Receiver" />
                    ) : (
                      "Sample Receiver"
                    )}
                  </div>
                </div>

                <div className="text-center">
                  <div className="arrow-down">
                    <FontAwesomeIcon icon={faArrowDownLong} />
                  </div>
                  <div className="box pink">
                    {isGenerated ? (
                      <OrgChartInput placeholder="Name Of Sampler" />
                    ) : (
                      "Sampler"
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default OrganizationChart;
